import { SidebarFeatureEnum } from 'config/types/sidebar'
import React from 'react'
import { useToggleSidebar } from 'state/app/hooks'
import Tournament from 'views/Tournament'

const SidebarFeatures: React.FC = () => {
  const { featureActive } = useToggleSidebar()

  return <>{featureActive === SidebarFeatureEnum.Tournament && <Tournament />}</>
}

export default SidebarFeatures
